import { fetchVideoMetadataAndNextResources } from '@redux/common/thunks';
import { isNotPremiumError } from '@redux/common/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { layoutInitialState } from './constants';
import { LayoutMode } from './types';

const layoutSlice = createSlice({
  name: 'layout',
  initialState: layoutInitialState,
  reducers: {
    openNotPremiumModal: (state) => {
      state.isNotPremiumModalOpen = true;
    },
    closeNotPremiumModal: (state) => {
      state.isNotPremiumModalOpen = false;
    },
    setLayoutMode: (state, action: PayloadAction<LayoutMode>) => {
      state.layoutMode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchVideoMetadataAndNextResources.rejected, (state, action) => {
      if (isNotPremiumError(action.payload)) {
        state.isNotPremiumModalOpen = true;
      }
    });
  },
});

export const { openNotPremiumModal, closeNotPremiumModal, setLayoutMode } = layoutSlice.actions;

export default layoutSlice.reducer;
